const initialState = {
  serviceWorkerInitialized: false,
  serviceWorkerUpdated: false,
  latestServiceWorkerLoaded: false,
  serviceWorkerRegistration: null,
};

export default initialState;